import { render, staticRenderFns } from "./NotificationToggle.vue?vue&type=template&id=fbaadfb6"
import script from "./NotificationToggle.vue?vue&type=script&lang=js"
export * from "./NotificationToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports